import { Timestamp } from './common.js'

export class UnsupportedGpxSegmentsError extends Error {
  readonly code = 'unsupported_gpx_segments'

  constructor() {
    super(
      'Routes require one continuous GPX segment. Split this file into separate routes before importing.',
    )
    this.name = 'UnsupportedGpxSegmentsError'
  }
}

/** Empty segments carry no geometry; never join two nonempty segments. */
export function singleGpxSegment<T>(segments: T[][]): T[] {
  const nonempty = segments.filter((segment) => segment.length > 0)
  if (nonempty.length > 1) throw new UnsupportedGpxSegmentsError()
  return nonempty[0] ?? []
}

/** Sum segment elapsed times, not moving time; incomplete or reversed clocks are unknown. */
export function gpxElapsedSeconds(
  segments: ReadonlyArray<ReadonlyArray<{ time?: string }>>,
): number | undefined {
  let elapsed = 0
  let hasPoint = false
  for (const segment of segments) {
    let previous: number | undefined
    for (const point of segment) {
      hasPoint = true
      if (!point.time || !Timestamp.safeParse(point.time).success) return undefined
      const current = Date.parse(point.time)
      if (!Number.isFinite(current) || (previous !== undefined && current < previous))
        return undefined
      if (previous !== undefined) elapsed += current - previous
      previous = current
    }
  }
  return hasPoint ? Math.round(elapsed / 1000) : undefined
}
